<template>
    <CModal :model-value="true" @update:model-value="onModalValueUpdate">
        <div
            class="mx-auto mb-8 flex size-20 items-center justify-center rounded-full border shadow-md sm:mb-12 sm:mt-8"
        >
            <CIcon class="text-green-500" name="checkmark" size="large" />
        </div>
        <div class="text-center">
            <CHeading tag="h1" variant="3">
                <template v-if="registeredUser"> Prihlásenie bolo úspešné </template>
                <template v-else> Už len krok <br class="hidden sm:block" />k prihláseniu do newslettera! </template>
            </CHeading>
            <template v-if="registeredUser">
                <p>
                    GROWNi newsletter bude odteraz chodiť na emailovú adresu
                    <strong> {{ email }} </strong>.
                </p>
                <p>Ďakujeme za záujem o novinky.</p>
            </template>
            <template v-else>
                <p>
                    Na <strong>{{ email }}</strong> sme práve odoslali link na overenie správnosti tejto emailovej
                    adresy.
                </p>
                <p>Ak nebude v <em>Doručenej pošte</em>, pozri aj <em>Spam</em>.</p>
            </template>
        </div>
        <template #footer>
            <div class="flex flex-col items-center">
                <CButton class="w-full sm:w-1/2" size="large" variant="primary-150" @click="close"> OK </CButton>
            </div>
        </template>
    </CModal>
</template>

<script setup lang="ts">
interface Props {
    email?: string
    registeredUser?: boolean
}

withDefaults(defineProps<Props>(), {
    email: '',
    registeredUser: false
})

const emits = defineEmits(['close'])

function onModalValueUpdate(isOpen: boolean) {
    if (!isOpen) {
        close()
    }
}

function close(result?: string) {
    emits('close', result)
}
</script>
